import React from 'react';
import { IStateProvinces } from '~/interfaces/states-provinces';
import { classes } from '../utils';

interface ICustomInputProps {
  value: string | boolean;
  disabled: boolean;
  ModuleClassName: string;
  onDropdownChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  label: string;
  selectLabel?: string;
  error?: string;
  name?: string;
  dropdownOptions?: IStateProvinces[];
  id?: string;
  onBlur: (event: React.FocusEvent<HTMLSelectElement>) => void;
}

const InputDropdown: React.FC<ICustomInputProps> = ({
  value,
  disabled,
  label,
  selectLabel,
  error,
  name,
  dropdownOptions,
  onDropdownChange,
  ModuleClassName,
  id,
  onBlur,
}) => {
  const getDropdownOptions = (_dropdownOptions?: IStateProvinces[]) => {
    return _dropdownOptions?.map((dropdownOption, i) => {
      return (
        <option key={`${id}-input-${i + 1}`} value={dropdownOption.StateId}>
          {dropdownOption.StateName}
        </option>
      );
    });
  };
  const divClass = classes(
    ModuleClassName,
    error ? 'mfrmFormGroup formError' : 'mfrmFormGroup',
  );
  return (
    <div className={divClass} id={`${id}_container`}>
      <label htmlFor={id} className="focused">
        {label}
      </label>
      <select
        id={id}
        onChange={onDropdownChange}
        name={name}
        value={`${value}`}
        aria-invalid={!!error}
        aria-required="true"
        onBlur={onBlur}
        disabled={disabled}
      >
        <option key={`${id}-input-${1}`} value="">
          {selectLabel}
        </option>
        {getDropdownOptions(dropdownOptions)}
      </select>
      {error && <p id={`error_${id}`}>{error}</p>}
    </div>
  );
};

export default InputDropdown;
